<template>
  <v-list-item>
      <v-layout row>
          <v-flex xs8>
              <span>{{ getTypeName(type) }}</span>
          </v-flex>
          <v-flex style="text-align:right;" xs4>
              <span @click="deleteEvent" style="cursor:pointer;"><i class="fal fa-trash"></i></span>
          </v-flex>
      </v-layout>
  </v-list-item>
</template>

<script>
import { Functions } from '../../logic/Functions'
import { Notifications } from '../../notification';
export default {
    name: "FunctionEvent",
    props: {
        id: {
            type: Number,
            required: true
        },
        type: {
            type: Number,
            required: true
        }
    },
    methods: {
        getTypeName(type_id) {
            var name = "";
            Functions.event_types.forEach(function(type) {
                if (type.value === parseInt(type_id)) {
                    name = type.text;
                }
            });
            return name;
        },
        async deleteEvent() {
            var response = await Functions.unregisterEvent(this.id);
            if (response.status === 200) {
                Notifications.show("The event has been unregistered.");
                this.$emit("eventDeleted");
            }
        }
    }
}
</script>

<style>

</style>